import { render, staticRenderFns } from "./CandidateTabsPanel.vue?vue&type=template&id=0f130745&scoped=true&"
import script from "./CandidateTabsPanel.vue?vue&type=script&lang=js&"
export * from "./CandidateTabsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CandidateTabsPanel.vue?vue&type=style&index=0&id=0f130745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f130745",
  null
  
)

/* custom blocks */
import block0 from "./CandidateTabsPanel.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateTabsPanel.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
